import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { Select, MenuItem } from '@material-ui/core';

const toDropDown = (lang) => ({
  text: lang.display || lang.lang,
  value: lang.lang,
});

const LanguageSelectorView = ({ languages, currentLanguage, onChangeLanguage }) => (
  <Select selection defaultValue={currentLanguage} onChange={onChangeLanguage}>
    {languages.map((language, index) => {
      const { value, text } = toDropDown(language);
      return (
        <MenuItem key={index} value={value}>
          {text}
        </MenuItem>
      );
    })}
  </Select>
);

class LanguageSelector extends Component {
  setLanguage(lang) {
    if (lang) {
      this.props.onChangeLanguage(lang);
    }
  }

  handleChangeLanguage = (event, data) => {
    this.setLanguage(data.value);
  };

  render() {
    const { languages, currentLanguage } = this.props;
    return (
      <LanguageSelectorView
        languages={languages}
        currentLanguage={currentLanguage}
        onChangeLanguage={this.handleChangeLanguage}
      />
    );
  }
}

LanguageSelector.propTypes = {
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      lang: PropTypes.string.isRequired,
      display: PropTypes.string,
    })
  ),
  currentLanguage: PropTypes.string,
  onChangeLanguage: PropTypes.func,
  langQuery: PropTypes.string,
};

LanguageSelector.defaultProps = {
  languages: [],
  langQuery: 'lang',
};

const LanguageHOC = compose(
  withRouter,
  withTranslation(),
  withProps(({ i18n }) => ({
    onChangeLanguage: (lang) => {
      i18n.changeLanguage(lang);
    },
    currentLanguage: i18n.language,
  }))
);

export default LanguageHOC(LanguageSelector);
